import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from '../../app.component';
import { PucComponent } from '../../components/page-under-construction/puc.component';
import { LoginComponent } from '../../components/pages/login/login.component';
import { AdmincontentComponent } from '../../components/admin-content/admincontent/admincontent.component';
import { AuthenticationGuard } from '../../guards/auth.guard';
import { ListusersComponent } from '../../components/pages/users/admin/listusers/listusers.component';
import { AdduserComponent } from '../../components/pages/users/admin/adduser/adduser.component';
import { EdituserComponent } from '../../components/pages/users/admin/edituser/edituser.component';
import { InvestorUserListComponent } from '../../components/pages/users/investor/listuser/investor-user-list.component';
import { InvestorAddUserComponent } from '../../components/pages/users/investor/adduser/investor-add-user.component';
import { InvestorEditUserComponent } from '../../components/pages/users/investor/edituser/investor-edit-user.component';
import { LogsComponent } from '../../components/pages/users/logs/logs.component';
import { IssuersComponent } from '../../components/pages/users/issuers/issuers.component';
import { IssuerAddUserComponent } from '../../components/pages/users/issuers/add-user/add-user.component';
import { IssuerEditUserComponent } from '../../components/pages/users/issuers/edit-user/edit-user.component';
import { KycComponent } from '../../components/pages/kyc/kyc.component';




const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: '', component: AdmincontentComponent, children: [
      {
        path: 'admin', children: [
          { path: 'user-lists', component: ListusersComponent },
          { path: 'add-user', component: AdduserComponent },
          { path: 'edit-user', component: EdituserComponent },
          { path: 'edit-user/:id', component: EdituserComponent },
          { path: 'user-logs', component: LogsComponent },
          { path: 'user-logs/:id', component: LogsComponent }
        ]
      },
      {
        path: 'investor', children: [
          { path: 'user-lists', component: InvestorUserListComponent },
          { path: 'add-user', component: InvestorAddUserComponent },
          { path: 'edit-user', component: InvestorEditUserComponent },
          { path: 'edit-user/:id', component: InvestorEditUserComponent },
          { path: 'view', component: InvestorEditUserComponent, data: { type: 'view' } },
          { path: 'user-logs', component: LogsComponent },
          { path: 'user-logs/:id', component: LogsComponent }
        ]
      },
      {
        path: 'issuer', children: [
          { path: 'user-lists', component: IssuersComponent },
          { path: 'add-user', component: IssuerAddUserComponent },
          { path: 'edit-user', component: IssuerEditUserComponent },
          { path: 'edit-user/:id', component: IssuerEditUserComponent },
          { path: 'user-logs', component: LogsComponent },
          { path: 'user-logs/:id', component: LogsComponent }
        ]
      },
      {
        path: 'kyc', children: [
          { path: 'list', component: KycComponent }
        ]
      },
      { path: 'page-under-construction', component: PucComponent },
    ]
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [
    RouterModule
  ],
  providers: []
})
export class HybseRoutingModule { }



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/modules/routing/app.routing.module.ts